<template>
  <div class="social-bar" :class="{ visible: scrolled && !isScrolling }">
    <ClientOnly>
      <div class="icon-holder rounded-left">
        <div class="pb-2">
          <a
            href="https://www.facebook.com/SalamisBayContiResortHotel/"
            target="_blank"
            rel="noopener noreferrer nofollow"
            class="text-white"
            alt="Facebook Logo"
            aria-label="Facebook Logo"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
            >
              <path
                fill="currentColor"
                d="M17 1H3c-1.1 0-2 .9-2 2v14c0 1.101.9 2 2 2h7v-7H8V9.525h2v-2.05c0-2.164 1.212-3.684 3.766-3.684l1.803.002v2.605h-1.197c-.994 0-1.372.746-1.372 1.438v1.69h2.568L15 12h-2v7h4c1.1 0 2-.899 2-2V3c0-1.1-.9-2-2-2"
              />
            </svg>
          </a>
        </div>
        <div class="pb-2">
          <a
            href="https://www.instagram.com/salamisbaycontiresort/"
            target="_blank"
            rel="noopener noreferrer nofollow"
            class="text-white"
            alt="Instagram Logo"
            aria-label="Instagram Logo"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
            >
              <path
                fill="currentColor"
                d="M17 1H3c-1.1 0-2 .9-2 2v14c0 1.101.9 2 2 2h14c1.1 0 2-.899 2-2V3c0-1.1-.9-2-2-2M9.984 15.523a5.54 5.54 0 0 0 5.538-5.539c0-.338-.043-.664-.103-.984H17v7.216a.69.69 0 0 1-.693.69H3.693a.69.69 0 0 1-.693-.69V9h1.549c-.061.32-.104.646-.104.984a5.54 5.54 0 0 0 5.539 5.539M6.523 9.984a3.461 3.461 0 1 1 6.922 0a3.461 3.461 0 0 1-6.922 0M16.307 6h-1.615A.694.694 0 0 1 14 5.308V3.691c0-.382.31-.691.691-.691h1.615c.384 0 .694.309.694.691v1.616c0 .381-.31.693-.693.693"
              />
            </svg>
          </a>
        </div>
        <div class="pb-2">
          <a
            href="https://www.youtube.com/channel/UCMT2lcf1B9A9DWMYwqVYnFw"
            target="_blank"
            rel="noopener noreferrer nofollow"
            class="text-white"
            alt="Youtube Logo"
            aria-label="Youtube Logo"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
            >
              <path
                fill="currentColor"
                d="M10 2.3C.172 2.3 0 3.174 0 10s.172 7.7 10 7.7s10-.874 10-7.7s-.172-7.7-10-7.7m3.205 8.034l-4.49 2.096c-.393.182-.715-.022-.715-.456V8.026c0-.433.322-.638.715-.456l4.49 2.096c.393.184.393.484 0 .668"
              />
            </svg>
          </a>
        </div>
        <div class="pb-2">
          <a
            href="https://www.linkedin.com/company/salamis-bay-conti/"
            target="_blank"
            rel="noopener noreferrer nofollow"
            class="text-white"
            alt="Linkedin Logo"
            aria-label="Linkedin Logo"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
            >
              <path
                fill="currentColor"
                d="M5 3c0 1.062-.71 1.976-2.001 1.976C1.784 4.976 1 4.114 1 3.052C1 1.962 1.76 1 3 1s1.976.91 2 2M1 19V6h4v13zm6-8.556c0-1.545-.051-2.836-.102-3.951h3.594l.178 1.723h.076c.506-.811 1.746-2 3.822-2C17.1 6.216 19 7.911 19 11.558V19h-4v-6.861c0-1.594-.607-2.81-2-2.81c-1.062 0-1.594.86-1.873 1.569c-.102.254-.127.608-.127.963V19H7z"
              />
            </svg>
          </a>
        </div>
        <div>
          <a
            href="https://www.tiktok.com/@salamisbaycontiresort"
            target="_blank"
            rel="noopener noreferrer nofollow"
            class="text-white"
            alt="TikTok Logo"
            aria-label="TikTok Logo"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
            >
              <path
                fill="currentColor"
                d="M12.53.02C13.84 0 15.14.01 16.44 0c.08 1.53.63 3.09 1.75 4.17c1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97c-.57-.26-1.1-.59-1.62-.93c-.01 2.92.01 5.84-.02 8.75c-.08 1.4-.54 2.79-1.35 3.94c-1.31 1.92-3.58 3.17-5.91 3.21c-1.43.08-2.86-.31-4.08-1.03c-2.02-1.19-3.44-3.37-3.65-5.71c-.02-.5-.03-1-.01-1.49c.18-1.9 1.12-3.72 2.58-4.96c1.66-1.44 3.98-2.13 6.15-1.72c.02 1.48-.04 2.96-.04 4.44c-.99-.32-2.15-.23-3.02.37c-.63.41-1.11 1.04-1.36 1.75c-.21.51-.15 1.07-.14 1.61c.24 1.64 1.82 3.02 3.5 2.87c1.12-.01 2.19-.66 2.77-1.61c.19-.33.4-.67.41-1.06c.1-1.79.06-3.57.07-5.36c.01-4.03-.01-8.05.02-12.07z"
              />
            </svg>
          </a>
        </div>
      </div>
      <PageInstagramBadge
        v-if="pageInstagram"
        :key="pageInstagram.username"
        :username="pageInstagram.username"
      />
    </ClientOnly>
  </div>
</template>

<script setup>
const route = useRoute();

const { isScrolling } = useScrollHide();

const scrolled = ref(false);
const onScroll = () => { scrolled.value = window.scrollY > 80; };
onMounted(() => {
  window.addEventListener('scroll', onScroll, { passive: true });
});
onBeforeUnmount(() => window.removeEventListener('scroll', onScroll));

const stripLocale = (path) => path.replace(/^\/en(\/|$)/, '/');

const pageInstagram = computed(() => {
  const path = stripLocale(route.path);
  const hash = route.hash?.replace('#', '');

  if (path === '/events') {
    if (hash === 'weddings') return { username: 'salamisbanket' };
    return { username: 'salamisentertainment' };
  }

  if (path.startsWith('/flavors/')) {
    const slug = path.split('/').pop();
    if (slug === 'chinese-restaurant') return { username: 'salamischinese' };
    if (slug === 'italian-restaurant') return { username: 'salamisitalian' };
    return null;
  }

  if (path === '/spa') return { username: 'salamishotellemonspa' };
  if (path === '/career') return { username: 'salamiskariyer' };

  return null;
});
</script>

<style scoped>
.social-bar {
  position: fixed;
  right: 0;
  bottom: 35%;
  z-index: 99;
  opacity: 0;
  pointer-events: none;
  transform: translateX(100%);
  transition: opacity 300ms ease, transform 300ms ease;
}
.social-bar.visible {
  opacity: 1;
  pointer-events: auto;
  transform: translateX(0);
}
.icon-holder {
  background-color: #042333;
  padding-top: 10px;
  padding-bottom: 10px;
  display: flex;
  flex-direction: column;
  padding-inline: 10px;
  border-top: 2px solid #e7bb7f;
  border-left: 2px solid #e7bb7f;
  border-bottom: 2px solid #e7bb7f;
}

@media (max-width: 968px) {
  .social-bar {
    bottom: 35%;
  }
}
</style>
